export default __webpack_public_path__ + "fc4ac555bf499bb5b34df78e1679d43c.png";